var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.12 164V180.879V186.836V233.998H600.621V250.38V256.834V461.036H622.054V477.748H681V582H293V233.294H360.138V164H608.12Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1261.33 183V188.623H1265.13V239.228V248.133H1270V259.063V582H983V463.259H1036.29V183H1261.33Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1499.16 164V473.084H1517V519.449H1488.27V582H1270.28V282.648V264.777V248.394H1265.32V188.833H1261.85V183.215H1258V164H1499.16Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1730 164V232.754H1721.05V246.304H1711.2V466.144H1715.16V519H1517.81V472.89H1500V460.494V164H1730Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 13,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2180 165V689H1994.95H1972.13H1882.33V581.818H1840.66H1819.82H1797V571.894V559.489V509.867H1813.2V462.727H1937.22V235.531H1933.5V165H2180Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1728 582V910.646H1708.2V931H1494V691.091H1544.39V582H1728Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1544 582V691.218H1493.48V931H1282.67V891.57V881.356H1270V582H1544Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1269.61 582V880.978H1282V934.031V945.011V997H1068.43H1055.05H1044.64V700.501H1038.7V688.601H983V582H1269.61Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.916 631V688.946H1039.04V700.832H1045V997H1035.07H1024.14H821V631H982.916Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821 631V997H600V702.015H622.298V686.62H681.408V631H821Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M681 582V622.269V629.584V686.11H621.963V701.694H599.629V997H360.541V936.085H293V582H681Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M832 183H608.509V234.064H601V460.627H622.27V477.483H681.133V534H811.719V525.572H831.011V462.61H813.203V238.03H832V183Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M1881.89 582H1727.87V910.53H1708V981H2180V689.194H1881.89V582Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor3);
export default __webpack_public_path__ + "static/media/select-floor-3.3728caba.svg";
export { ForwardRef as ReactComponent };